import { EMAIL_REGEX } from '@asgard/utils';
import { TFunction } from 'hooks/useI18n';
import { UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

export const TalentEngineFormFieldsSchema = z
  .object({
    name: z.string().nonempty({
      message:
        'talent-engine-landing-v3:talent-engine-landing.form.messages.name_required'
    }),
    company: z.string().nonempty({
      message:
        'talent-engine-landing-v3:talent-engine-landing.form.messages.company_required'
    }),
    email: z.string().nonempty({
      message:
        'talent-engine-landing-v3:talent-engine-landing.form.messages.email_required'
    })
  })
  .refine((schema) => schema.email?.match(EMAIL_REGEX), {
    path: ['email'],
    message: `talent-engine-landing-v3:talent-engine-landing.form.messages.email_invalid`
  });

export type TalentEngineFormFields = z.infer<
  typeof TalentEngineFormFieldsSchema
>;

type UseTalentEngineReturn = {
  t: TFunction;
  onSubmit: (values: TalentEngineFormFields) => Promise<void>;
  formMethods: UseFormReturn<TalentEngineFormFields>;
  isFormFilled: boolean;
  onFormFieldFocus: () => void;
};

export type UseTalentEngineForm = () => UseTalentEngineReturn;
